<script>
    export let userId
    export let firebase

    let deviceId = "-"
    let platform = "-"
    let startVersion = "-"
    let currentVersion = "-"
    let lastSeen = "-"
    let rubies = 0
    let gold = 0
    let rubiesSent = 0
    let userProgress = []
    let lastBoutique = "Boutique1"
    let lastLevel = 1
    let marks = {
        manual: {},
        auto: {}
    }
    let userDataDocumentRef
    const availableMarks = ["Developer", "Cheater"]

    firebase.firestore()
        .collection("HelpDeskTickets")
        .where("userId", "==", userId)
        .onSnapshot(querySnapshot => {
            rubiesSent = querySnapshot.docs.map(ticket => {
                const messages = ticket.data().messages
                if (!messages) return 0

                return messages.map(m => (m.parameter && m.parameter.Rubies) ? m.parameter.Rubies : 0)
            })
            .flat()
            .reduce((acc, e) => acc + e, 0)
        }, err => {
            console.log(`Encountered error: ${err}`)
        })

    firebase.firestore()
        .collection("UserData")
        .doc(userId)
        .get()
        .then(doc => {
            if (doc.exists) {
                userDataDocumentRef = doc.ref
                const data = doc.data()
                const progress = data.progress
                const stagesProgress = Object.keys(progress).map(e => ({ id: e, level: progress[e] }))
                stagesProgress.sort((a, b) => {
                    if (a.id < b.id) return -1
                    if (a.id > b.id) return 1
                    return 0
                })
                userProgress = stagesProgress
                if (stagesProgress.length > 0) {
                    const last = stagesProgress[stagesProgress.length - 1]
                    lastBoutique = last.id
                    lastLevel = last.level
                }
                if (data.marks) {
                    marks = data.marks
                }
                currentVersion = data.currentVersion ?? "-"
                startVersion = data.startVersion ?? "-"
                lastSeen = data.lastSeen ? new Date(data.lastSeen).toLocaleString() : "-"
                rubies = data.rubies ?? 0
                gold = data.gold ?? 0
                platform = data.platform ?? "-"
                deviceId = data.deviceId ?? "-"
            }
        })
    
    function switchMark(mark) {
        marks.manual[mark] = marks.manual[mark] ? false : true

        if (userDataDocumentRef) {
            userDataDocumentRef
                .update({ marks })
                .then(() => userDataDocumentRef.get())
                .then(doc => marks = doc.data().marks)
        }
    }

    function resolveMark(marks, mark) {
        if (marks.manual[mark] !== undefined) {
            return marks.manual[mark]
        }
        return marks.auto[mark]
    }
</script>


<div class="plugin-container">
    <div>Device Id: <b>{deviceId}</b></div>
    <div>Platform: <b>{platform}</b></div>
    <div>Start version: <b>{startVersion}</b></div>
    <div>Current version: <b>{currentVersion}</b></div>
    <div>Last seen: <b>{lastSeen}</b></div>
    <div>Rubies: <b>{rubies}</b></div>
    <div>Gold: <b>{gold}</b></div>
    <div>
        <a class="modal-trigger" href="#progressModal">Progress: {lastBoutique} - level {lastLevel}</a>
        <div id="progressModal" class="modal">
            <div class="modal-content">
                <h4>User progress</h4>
                <ul class="collection">
                    {#each userProgress as stage (stage.id)}
                        <li class="collection-item avatar">
                            <img src="stages/{stage.id}.png" alt="" class="circle">
                            <span class="title">{stage.id}</span>
                            <p>Level: {stage.level}</p>
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
    <div>
        Already sent:
        <div class="chip">
            <img src={`items/Rubies.png`} alt="Rubies" /> {rubiesSent}
        </div>
    </div>
    <div>
        Marks:
        {#each availableMarks as availableMark}
            {#if resolveMark(marks, availableMark)}
                <div class="chip {String(availableMark).toLowerCase()}">
                    {availableMark}
                </div>
            {/if}
        {/each}
        <a class="btn-floating modal-trigger" href="#marksModal">
            <i class="material-icons">edit</i>
        </a>
        <div id="marksModal" class="modal">
            <div class="modal-content">
                <h4>User marks</h4>
                <ul class="collection">
                    {#each availableMarks as availableMark}
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a class="collection-item {resolveMark(marks, availableMark) ? 'active' : ''}" on:click="{() => { switchMark(availableMark) }}">{availableMark}</a>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</div>

<style>
    .developer {
        background-color: #1B5E20;
        color: white;
    }
    .cheater {
        background-color: #BF360C;
        color: white;
    }
</style>